import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  space?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Divider',
  props: {
    space: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("hr", {
    class: _normalizeClass(["text-tile-border", props.space ? 'my-6' : 'my-2'])
  }, null, 2 /* CLASS */))
}
}

})